import useEntity from 'core/hooks/useEntity'

const usePerson = (...args) => useEntity('people', ...args)
export default usePerson
